<template>
  <div>
    <v-layout wrap justify-center>
      <v-flex>
        <Carousal />
        <BestSellers />
        <BannerAds v-bind:adds="2" />
        <DailyEssentials />
        <NewProductAds v-bind:adds="3" />
        <BannerAds v-bind:adds="1" />
        <ProductAds v-bind:adds="3" />
        <Groceries />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import Carousal from "./../Home/carousal";
import BestSellers from "./../Home/bestSellers";
import BannerAds from "./../Home/bannerAds";
import DailyEssentials from "./../Home/dailyEssentials";
import NewProductAds from "./../Home/newProductAds";
import ProductAds from "./../Home/productAds";
import Groceries from "./../Home/groceries";
export default {
  components: {
    Carousal,
    BestSellers,
    BannerAds,
    DailyEssentials,
    NewProductAds,
    ProductAds,
    Groceries,
  },
  data() {
    return {
      adds: {
        name: "Test Add",
        items: 2,
      },
    };
  },
};
</script>